import { Box, Checkbox, Flex, Text, useColorModeValue } from "@chakra-ui/react";

export interface CandidateSelectAllProps {
  selectedCount: number;
  totalCount: number;
  onToggle: () => void;
}

export const CandidateSelectAll = ({
  selectedCount,
  totalCount,
  onToggle,
}: CandidateSelectAllProps) => {
  const selectionActiveBorder = useColorModeValue("blue.100", "gray.100");
  const selectionActiveBg     = useColorModeValue("rgba(235,244,255,0.8)", "rgba(0,114,255,0.06)");
  const selectionActiveText   = useColorModeValue("blue.600", "blue.300");

  const hasSelection = selectedCount > 0;
  const isAllSelected = hasSelection && selectedCount === totalCount;

  return (
    <Flex
      align="center"
      display="inline-flex"
      mb={3}
      px={3}
      py={2}
      borderRadius="lg"
      borderWidth="1px"
      borderColor={hasSelection ? selectionActiveBorder : "gray.100"}
      bg={hasSelection ? selectionActiveBg : "transparent"}
      transition="all 0.15s"
    >
      <Checkbox
        colorScheme="blue"
        isChecked={isAllSelected}
        isIndeterminate={hasSelection && !isAllSelected}
        onChange={onToggle}
      >
        <Text
          fontSize="sm"
          fontWeight={hasSelection ? "semibold" : "medium"}
          color={hasSelection ? selectionActiveText : "gray.500"}
        >
          {hasSelection
            ? `${selectedCount} de ${totalCount} selecionado${selectedCount !== 1 ? "s" : ""}`
            : `Selecionar todos (${totalCount})`
          }
        </Text>
      </Checkbox>
    </Flex>
  );
};
